"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FunnelQuestion = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TrustReview = _interopRequireDefault(require("./TrustReview"));

var _reactI18next = require("react-i18next");

var _maschinenbaupalmLogo = _interopRequireDefault(require("./maschinenbaupalm-logo.jpg"));

var _talentselectLogo = _interopRequireDefault(require("./talentselect-logo.jpg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      height: '100%',
      padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(1), "px"),
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: theme.breakpoints.values.lg
    },
    progress: {
      margin: "0px ".concat(theme.spacing(3), "px"),
      borderRadius: 20,
      height: 6
    },
    questionContainer: {
      padding: theme.spacing(3)
    },
    actionsContainer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    trustSignal: {
      marginTop: theme.spacing(2)
    },
    trustReview: {
      flex: 1
    }
  };
});

var FunnelQuestion = function FunnelQuestion(_ref) {
  var className = _ref.className,
      title = _ref.title,
      subtitle = _ref.subtitle,
      progress = _ref.progress,
      children = _ref.children,
      actions = _ref.actions,
      hideProgress = _ref.hideProgress,
      questionHeader = _ref.questionHeader,
      props = _objectWithoutProperties(_ref, ["className", "title", "subtitle", "progress", "children", "actions", "hideProgress", "questionHeader"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h2",
    align: "center"
  }, title))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    align: "center"
  }, subtitle)), !hideProgress && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    variant: "determinate",
    value: progress || 0,
    className: classes.progress,
    color: "secondary"
  })), questionHeader && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    align: "center",
    variant: "h5"
  }, questionHeader)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.questionContainer
  }, children)), actions && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actionsContainer
  }, actions)))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    justify: "center",
    alignItems: "stretch",
    alignContent: "stretch",
    className: classes.trustSignal
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.trustReview
  }, /*#__PURE__*/_react.default.createElement(_TrustReview.default, {
    avatarSrc: _maschinenbaupalmLogo.default,
    reviewerName: t('reviews.maschinenbaupalm.name'),
    stars: 5,
    content: t('reviews.maschinenbaupalm.content')
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.trustReview
  }, /*#__PURE__*/_react.default.createElement(_TrustReview.default, {
    avatarSrc: _talentselectLogo.default,
    reviewerName: t('reviews.talentselect.name'),
    stars: 5,
    content: t('reviews.talentselect.content')
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.provenexpert.com/leanlancer/?utm_source=Widget&utm_medium=Widget&utm_campaign=Widget",
    rel: "nofollow",
    title: "Kundenbewertungen & Erfahrungen zu LeanLancer. Mehr Infos anzeigen.",
    target: "_blank" // eslint-disable-line
    ,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://images.provenexpert.com/fe/b4/f5b78e04a63953e13a2bd76fc03a/widget_portrait_150_de_0.png",
    alt: "Erfahrungen & Bewertungen zu LeanLancer",
    width: "150",
    height: "180",
    style: {
      border: '0'
    }
  })))));
};

exports.FunnelQuestion = FunnelQuestion;
FunnelQuestion.propTypes = {
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  questionHeader: _propTypes.default.string,
  progress: _propTypes.default.number,
  actions: _propTypes.default.node,
  hideProgress: _propTypes.default.bool.isRequired
};
FunnelQuestion.defaultProps = {
  hideProgress: false
};
var _default = FunnelQuestion;
exports.default = _default;